import { render, staticRenderFns } from "./ClassGlossary.vue?vue&type=template&id=3a1f5a32&"
import script from "./ClassGlossary.vue?vue&type=script&lang=js&"
export * from "./ClassGlossary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1f5a32')) {
      api.createRecord('3a1f5a32', component.options)
    } else {
      api.reload('3a1f5a32', component.options)
    }
    module.hot.accept("./ClassGlossary.vue?vue&type=template&id=3a1f5a32&", function () {
      api.rerender('3a1f5a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/ClassGlossary.vue"
export default component.exports